import React, { useEffect, useState } from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import { TextField, debounce } from "@mui/material";
import { Translations } from "../../../models/translations";
import { MuiDateRangePicker } from "../../framework/muiDatepicker";
import { CustomerSelect } from "../components/customerSelect";
import { getCustomerDetails } from "../../../services/customerService";
import { showApiError } from "../../framework/formUtils";
import { ICustomerDetails } from "../../../models/customer/customerDetails";

export interface TransportOrderFiltersProps {
    filterCustomer: string;
    setFilterCustomer: (customerId: string) => void;
    timeRange: [Date, Date];
    setTimeRange: (timeRange: [Date, Date]) => void;
    setKeyword: (keyword: string) => void;
    disabledCustomer?: boolean;
    selectedInvoiceCustomerId?: string;
}

export const TransportOrderFilters = ({
    filterCustomer,
    setFilterCustomer,
    timeRange,
    setTimeRange,
    setKeyword,
    disabledCustomer,
    selectedInvoiceCustomerId,
}: TransportOrderFiltersProps) => {
    const [selectedCustomer, setSelectedCustomer] = useState<ICustomerDetails>();

    const debouncedSetKeyword = debounce((value: string) => {
        setKeyword(value);
    }, 1000);

    useEffect(() => {
        if (selectedInvoiceCustomerId) {
            getCustomerDetails(selectedInvoiceCustomerId)
                .then((res) => {
                    setSelectedCustomer(res.data);
                })
                .catch((error) => {
                    showApiError(error.message);
                });
        }
    }, [selectedInvoiceCustomerId]);

    return (
        <div>
            <Grid2 container spacing={2}>
                <Grid2>
                    <MuiDateRangePicker
                        labels={[Translations.DateRangeStart, Translations.DateRangeEnd]}
                        value={timeRange}
                        onChange={setTimeRange}
                    />
                </Grid2>
                <Grid2>
                    {disabledCustomer ? (
                        <TextField
                            value={selectedCustomer?.name}
                            label={Translations.Customer}
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                readOnly: true,
                            }}
                            disabled
                        />
                    ) : (
                        <CustomerSelect
                            value={filterCustomer}
                            onChange={setFilterCustomer}
                            disabled={disabledCustomer}
                        />
                    )}
                </Grid2>
                <Grid2>
                    <TextField
                        label={Translations.Search}
                        onChange={(e) => debouncedSetKeyword(e.currentTarget.value)}
                    />
                </Grid2>
            </Grid2>
        </div>
    );
};
